CHAT_LIST_ENDPOINT